import { render } from "./App.vue?vue&type=template&id=46171994&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=46171994&lang=less"

import exportComponent from "/Users/fanglegefang/Desktop/Feiyi_sign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__